import {BridgeComponent} from "@hotwired/hotwire-native-bridge"

export class BridgeIdAustriaController extends BridgeComponent {
    static component = "id-austria"
    static values = {
        url: String
    }

    connect() {
        super.connect()
        if (!this.bridgeElement.enabled) return
        this.element.addEventListener("click", this.onClick)
    }

    disconnect() {
        this.element.removeEventListener("click", this.onClick)
        super.disconnect()
    }

    onClick = (event) => {
        // Intercept so the default link navigation to /id-austria does not fire
        // concurrently with the native hop.
        event.preventDefault()

        this.send("open", {
            url: this.urlValue
        }, (message) => {
            // Native replies with { opened: Bool }. true = iOS handed the
            // HTTPS URL off to the ID-Austria app via UL; we do nothing and
            // wait for the AASA callback. false = no installed app claims
            // the UL (or the cache isn't warm yet); navigate the WebView to
            // the same URL so the web flow takes over.
            if (!(message?.data ?? {}).opened) {
                window.location.href = this.urlValue
            }
        })
    }
}
